import styles from './PlanCardDiscountLabel.module.scss';
import { roundAmount } from 'src/utils';

interface PlanCardDiscountLabelV2Props {
  discountAmount: number;
}

export const PlanCardDiscountLabel = ({
  discountAmount,
}: PlanCardDiscountLabelV2Props) => {
  return (
    <span className={styles.root}>Save ${roundAmount(discountAmount)}</span>
  );
};
